export default "__VITE_ASSET__BhYeQeSV__"